<template>
  <v-row>
    <v-col cols="12">
      <!-- list filters -->
      <v-card class="pt-5">
        <v-card-title> Filtrar </v-card-title>

        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent="downloadExcel"
        >
          <v-row class="px-2 ma-0">
            <v-col
              cols="12"
              sm="4"
            >
              <VSelect
                v-model="filaSelecionada"
                :items="filas"
                item-text="nome"
                item-value="id"
                label="Fila"
                outlined
                dense
                :rules="[validators.select]"
                @click="getFilas"
              />
            </v-col>

            <v-col
              cols="12"
              md="2"
              sm="4"
            >
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateFormatted"
                    label="Período de:"
                    outlined
                    dense
                    clearable
                    hide-details
                    color="primary"
                    v-bind="attrs"
                    :rules="[validators.required]"
                    v-on="on"
                    @blur="filtroPeriodoInicio = parseDate(dateFormatted)"
                  />
                </template>

                <v-date-picker
                  v-model="filtroPeriodoInicio"
                  no-title
                  color="primary"
                  locale="pt-br"
                  @change="getRelatoriofila"
                  @input="menu1 = false"
                />
              </v-menu>
            </v-col>

            <v-col
              cols="12"
              md="2"
              sm="6"
            >
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="computedDateFormatted"
                    label="Período até:"
                    outlined
                    dense
                    clearable
                    hide-details
                    v-bind="attrs"
                    :rules="[validators.required]"
                    v-on="on"
                    @blur="filtroPeriodoFim = parseDate(computedDateFormatted)"
                  />
                </template>

                <v-date-picker
                  v-model="filtroPeriodoFim"
                  no-title
                  color="primary"
                  locale="pt-br"
                  @change="getRelatoriofila"
                  @input="menu2 = false"
                />
              </v-menu>
            </v-col>

            <v-col
              cols="12"
              md="2"
              sm="12"
              class="d-flex justify-start text-right"
            >
              <v-btn
                color="primary"
                type="submit"
                :loading="loadingButton"
              >
                <v-icon>{{ icons.mdiFileExcelOutline }}</v-icon>
                <span>Exportar</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      class=""
    >
      <relatorioFila
        :relatorio-data="relatorioTicketData"
        :loading.sync="loading"
        :array-vazio="arrayVazio"
      />
    </v-col>
  </v-row>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { mdiCalendar, mdiFileExcelOutline } from '@mdi/js'
import { required, select } from '@core/utils/validation'
import Vue from 'vue'
import { storeToRefs } from 'pinia'
import RelatorioFila from '@/views/relatorio/fila/CardsTicketsFila.vue'
import { downloadLink } from '@/views/relatorio/fila/DownloadExcel'
import FilaService from '@/services/modules/FilaService'
import useUserStore from '@/store/user'
import RelatorioService from '@/services/modules/RelatorioService'
import { getDataFinalMes, getDataInicialMes } from '@/utils/dateTime'

export default {
  components: {
    RelatorioFila,
  },

  setup() {
    const filas = ref([])
    const agentes = ref([])
    const filaSelecionada = ref('')
    const loading = ref(false)
    const loadingButton = false
    const arrayVazio = ref(false)
    const valid = ref(false)
    const form = ref(null)

    const validate = () => {
      form.value.validate()
    }

    const relatorioTicketData = ref([])

    const relatorioFormsData = ref([])

    async function downloadExcel() {
      downloadLink(relatorioTicketData.value, relatorioFormsData.value)
    }

    const filtroPeriodoInicio = ref(getDataInicialMes())
    const filtroPeriodoFim = ref(getDataFinalMes())

    const { id } = storeToRefs(useUserStore())

    const menu1 = ref(false)
    const menu2 = ref(false)

    const formatDate = dates => {
      if (!dates) return null
      const [year, month, day] = dates.split('-')

      return `${day}/${month}/${year}`
    }

    const parseDate = dates => {
      if (!dates) return null
      const [day, month, year] = dates.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }

    let dateFormatted = computed(() => formatDate(filtroPeriodoInicio.value))
    let computedDateFormatted = computed(() => formatDate(filtroPeriodoFim.value))

    watch(filtroPeriodoInicio, () => {
      dateFormatted = formatDate(filtroPeriodoInicio.value)
    })

    watch(filtroPeriodoFim, () => {
      computedDateFormatted = formatDate(filtroPeriodoFim.value)
    })

    async function getFilas() {
      filas.value = await FilaService.getFilasSemPaginacaoEContadoresSla(id.value)
    }

    const convertSecondsToMinutesToHours = totalMinutes => {
      const hours = Math.floor(totalMinutes / 3600)
      const remainingSeconds = totalMinutes % 3600
      const minutes = Math.floor(remainingSeconds / 60)
      const seconds = remainingSeconds % 60

      const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
      return formattedTime
    }

    const getRelatoriofila = async () => {
      arrayVazio.value = false
      loading.value = true

      if (Date.parse(filtroPeriodoFim.value) < Date.parse(filtroPeriodoInicio.value)) {
        Vue.$toast.warning('O periódo final deve ser menor que o periódo inicial!')
        loading.value = false
        return
      }

      const diferenca = Date.parse(filtroPeriodoFim.value) - Date.parse(filtroPeriodoInicio.value)
      const diferencaDias = diferenca / (1000 * 3600 * 24)

      if (diferencaDias >= 366) {
        Vue.$toast.warning('A diferença entre as datas deve ser de no máximo 365 dias!')
        loading.value = false
        return
      }

      if (filaSelecionada.value) {
        try {
          relatorioFormsData.value = await RelatorioService.getRelatorioTicketFormulariosRespostas(filaSelecionada.value, filtroPeriodoInicio.value, filtroPeriodoFim.value)

          const data = await RelatorioService.getRelatorioFila(filaSelecionada.value, filtroPeriodoInicio.value, filtroPeriodoFim.value)

          const formattedData = data.map(item => ({
            ...item,
            tempoTotalAtendimento: convertSecondsToMinutesToHours(item.tempoTotalAtendimento),
            tempoDePrimeiraResposta: convertSecondsToMinutesToHours(item.tempoDePrimeiraResposta),
            tempoMedioEntreRespostas: convertSecondsToMinutesToHours(item.tempoMedioEntreRespostas),
          }))

          relatorioTicketData.value = formattedData
          if (relatorioTicketData.value.length === 0) {
            arrayVazio.value = true
          } else {
            arrayVazio.value = false
          }
          loading.value = false
        } catch {
          loading.value = false
        }
      } else {
        loading.value = false
      }
    }

    watch(filaSelecionada, () => {
      getRelatoriofila()
    })

    return {
      filas,
      agentes,
      filaSelecionada,
      loading,
      loadingButton,
      filtroPeriodoFim,
      filtroPeriodoInicio,
      dateFormatted,
      menu1,
      menu2,
      computedDateFormatted,
      valid,
      form,
      relatorioTicketData,
      arrayVazio,
      convertSecondsToMinutesToHours,
      getFilas,
      getRelatoriofila,
      validate,
      parseDate,
      formatDate,
      downloadExcel,
      icons: { mdiCalendar, mdiFileExcelOutline },
      validators: {
        required,
        select,
      },
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
